import React from 'react'
import {Link} from "react-router-dom";
import { Alert, Button, Card, theme } from 'antd';

import { IMG_SERVICE_MAINTENANCE } from '../../../data/assets';
import {ROUTE_PATH} from "../../../data/configs/constants";

import ShowMessage from '../ShowMessage';

const MaintenanceOverlay = () => {
  const {token} = theme.useToken()

  return(
    <Card styles={{body: {padding: 0}}}>
      <Alert
        type='warning'
        message={
          <ShowMessage title="🔧 🚧 Service Under Maintenance!" src={IMG_SERVICE_MAINTENANCE} message={
            <span> The service you've requested is currently undergoing maintenance.
              <br />Please check back later to enjoy the service. Thank you for your patience! </span>}
          >
            <Link to={ROUTE_PATH.DASHBOARD}><Button style={{marginBlock: token.margin}} variant="filled" color="danger">Go to Home</Button></Link>
          </ShowMessage>
        }
      />
    </Card>
  )
}

export default MaintenanceOverlay